import { render, staticRenderFns } from "./PermissionManager.vue?vue&type=template&id=9356f6fc&"
import script from "./PermissionManager.vue?vue&type=script&lang=js&"
export * from "./PermissionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9356f6fc')) {
      api.createRecord('9356f6fc', component.options)
    } else {
      api.reload('9356f6fc', component.options)
    }
    module.hot.accept("./PermissionManager.vue?vue&type=template&id=9356f6fc&", function () {
      api.rerender('9356f6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/PermissionManager.vue"
export default component.exports